import { captureException } from '@sentry/react';
import { Query } from '@tanstack/react-query';

export class QueryError extends Error {
  public queryType: string;
  public queryKey: unknown[];

  constructor(
    public message: string,
    public query: Query,
  ) {
    super(message);
    this.name = 'QueryError';
    this.queryType = Array.isArray(query.queryKey)
      ? query.queryKey[0]
      : 'unknown';
    this.queryKey = [...query.queryKey];
  }

  capture() {
    captureException(this, {
      tags: {
        queryType: this.queryType, // Set queryType as a tag
      },
      extra: {
        queryKey: this.queryKey, // Include the queryKey for more context
      },
      fingerprint: ['QueryError', this.queryType],
    });
  }
}
